// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".logo_container[data-v-2ae4ce02] {\n  padding-top: 10px;\n  height: 60px;\n  margin-left: 15px;\n}\n", ""]);
// Exports
module.exports = exports;
